import { render } from "./EmployeLeftbar.vue?vue&type=template&id=fab94318"
import script from "./EmployeLeftbar.vue?vue&type=script&lang=js"
export * from "./EmployeLeftbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__